import { connect } from 'react-redux';

// actions
import { openQuitFlowModal } from 'current/uiwidgets';
import { closeMessage } from 'messages';
import { goBack, goForward, setStepActionsForManualScripts } from 'script-flow';

// selectors
import { isInitialLoadDone } from 'api/loading/selectors';
import {
  canGoBack,
  canGoForward,
  getSelectedManagementZonesType,
  isMultiLayerZoneGenerationEnabled
} from 'manual/selectors';
import { getActiveField } from 'current/selectors';
import { getAllMessages } from 'messages/selectors';
import { getStepNumber, isLastStep } from 'script-flow/selectors';

import ManualScript from './ManualScript';

export default connect(
  state => ({
    activeField: getActiveField(state),
    canGoBack: canGoBack(state),
    canGoForward: canGoForward(state),
    initialLoadIsInProgress: !isInitialLoadDone(state),
    isFinalStep: isLastStep(state),
    isMultiLayerEnabled: isMultiLayerZoneGenerationEnabled(state),
    messages: getAllMessages(state),
    selectedManagementZonesType: getSelectedManagementZonesType(state),
    stepNumber: getStepNumber(state)
  }),
  dispatch => ({
    closeMessage: id => {
      dispatch(closeMessage(id));
    },
    onClickBack: () => {
      dispatch(goBack());
    },
    onClickForward: () => {
      dispatch(setStepActionsForManualScripts());
      dispatch(goForward());
    },
    onClickCancel: () => {
      dispatch(openQuitFlowModal());
    }
  })
)(ManualScript);
